import React from "react";

interface PageHeaderProps {
    title: string;
    description?: string;
    action?: React.ReactNode;
    icon?: React.ElementType;
}

export const PageHeader = ({ 
    title, 
    description, 
    action, 
    icon: Icon 
}: PageHeaderProps) => {
    return (
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 mb-2 mt-0 border-b border-gray-100 pb-2">
            <div className="flex items-center gap-3">
                {Icon && <Icon className="h-5 w-5 text-legal-blue shrink-0 animate-fade-in" />}
                <div>
                    <h1 className="text-lg font-bold text-gray-900 leading-tight">{title}</h1>
                    {description && <p className="text-gray-400 text-xs mt-0.5">{description}</p>}
                </div>
            </div>
            {action && <div className="shrink-0 flex items-center">{action}</div>}
        </div>
    );
};

export default PageHeader;
